/** PrivacyChip's default label — shared with tests that select the marker by text
 *  (it renders no role/testid of its own). */
export const PRIVACY_CHIP_DEFAULT_LABEL = "Private to you";
